export default {
  nav: {
    portfolio: "Portfolio de Widyo",
    whyme: "¿Por qué yo?",
    education: "Educación",
    experience: "Experiencia",
    organizational: "Organización",
    events: "Eventos",
    portfolio_link: "Portfolio",
    skills: "Habilidades",
    certificates: "Certificados",
    awards: "Premios",
    contact: "Contacto",
    downloadResume: "Descargar CV",
    downloadPortfolio: "Descargar Portafolio",
    letsConnect: "Conectémonos",
  },
  hero: {
    greeting: "¡Hola!",
    name: "Soy Widyo Tri Cahya Utomo",
    nickname: "Dio",
    title: "Ingeniero DevOps | Ingeniero de Datos",
    description: "Ingeniero DevOps en Apple Developer Institute, automatizando infraestructura AWS como código con Terraform y Ansible y construyendo pipelines CI/CD. Respaldado por tres años de ingeniería de datos empresariales — ETL/CDC, migraciones a la nube y plataformas de datos.",
    downloadResume: "Descargar CV",
    contactMe: "Contáctame",
  },
  whyme: {
    title: "¿Por qué yo?",
    subtitle: "Lo que me hace diferente como ingeniero DevOps",
    content: "No solo muevo datos — los convierto en inteligencia que crea valor comercial real. Abordo cada problema con escepticismo curioso, validando suposiciones e ingeniería de sistemas que escalan, se mantienen confiables y realmente entregan resultados. Mi experiencia abarca ingeniería de datos de extremo a extremo, incluyendo ingestión, almacenamiento, orquestación, gobernanza y ajuste de rendimiento en pilas modernas. He trabajado en entornos empresariales donde el fracaso no es una opción, por lo que la fiabilidad, seguridad y precisión no son negociables. Estoy obsesionado con arquitectura limpia, pipelines eficientes y automatización que previene dolores de cabeza, no los causa. Con más de 40 certificaciones de la industria y un enfoque orientado al futuro en IA y Web3, construyo sistemas diseñados para las demandas de hoy y la innovación del mañana. En pocas palabras, entrego soluciones de datos construidas para impacto, escala y futuro.",
  },
  tools: {
    title: "Aquí están algunas de las herramientas y tecnologías que uso a diario",
  },
  education: {
    title: "Educación",
    subtitle: "Fundamento académico en Ingeniería Informática con fuerte enfoque en sistemas de datos",
    graduated: "Graduado",
    institutions: {
      maranatha: {
        name: "Universidad Cristiana Maranatha",
        degree: "Licenciatura en Ingeniería (B.E.), Ingeniería Informática",
        highlights: [
          "GPA: 3.83",
          "Cursos relevantes: Bases de datos, Sistemas Operativos, Redes de Computadoras",
        ],
      },
      yosuka: {
        name: "Escuela Secundaria Yos Sudarso - Karawang",
        degree: "Especialidad en Matemáticas y Ciencias",
        status: "Diploma de Secundaria",
      },
      akademicrypto: {
        name: "Akademi Crypto - Tangerang",
        degree: "Programa sin titulación en Web3 y Blockchain",
        status: "Mar 2024 - Presente",
        highlights: [
          "Enfoque en Web3, Fundamentos de Blockchain y Tecnologías Descentralizadas",
          "Aprendizaje activo en criptoeconomía, contratos inteligentes y ecosistemas DeFi",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - Jakarta",
        degree: "Programa sin titulación en Trading Financiero y Análisis de Mercado",
        status: "Sep 2025 - Presente",
        highlights: [
          "Enfoque en trading de criptomonedas utilizando análisis fundamental y técnico",
          "Desarrollo de estrategias de trading prácticas y habilidades de evaluación de mercado a través del aprendizaje comunitario",
        ],
      },
    },
  },
  experience: {
    title: "Experiencia",
    subtitle: "Automatización de infraestructura en la nube, además de ingeniería de datos empresariales y consultoría técnica en diversas industrias",
  },
  organizational: {
    title: "Organización y Comunidad",
    subtitle: "Roles de liderazgo y participación activa en organizaciones profesionales y comunitarias",
    activities: [
      {
        title: "Liderazgo Universitario",
        organization: "Universidad Cristiana Maranatha",
        role: "Jefe del Laboratorio de Computación Digital",
        dates: "Abr 2021 – Abr 2023",
        description: "Lideró el laboratorio, gestionó proyectos y mentoría estudiantil.",
      },
      {
        title: "Comunidades Cripto",
        organization: "Akademi Crypto, TradeWithSuli, Coin Kami",
        role: "Miembro Activo",
        dates: "Feb 2023 - Presente",
        description: "Participante activo y aprendiz de por vida en comunidades Web3 y cripto.",
      },
      {
        title: "Grupo de Conexión y Ministerio Multimedia",
        organization: "Iglesia Rose of Sharon",
        role: "Miembro Activo",
        dates: "Ago 2015 - Presente",
        description: "Activamente involucrado en la comunidad de la iglesia a través de la comunión del Grupo de Conexión y sirviendo en el Ministerio Multimedia, apoyando los servicios de adoración y la producción de medios creativos.",
      },
    ],
  },
  events: {
    title: "Eventos y Galería",
    subtitle: "Fotos y momentos destacados de eventos, conferencias, seminarios y actividades profesionales",
    noImages: "No hay imágenes disponibles",
    maintenance: "En Mantenimiento",
    maintenanceDesc: "Esta sección se está actualizando con nuevo contenido. ¡Vuelve pronto!",
  },
  portfolio: {
    title: "Portfolio",
    subtitle: "Proyectos seleccionados que muestran desarrollo web y trabajo de ingeniería de datos",
    webPortfolioTitle: "Portfolio Web",
    dataPortfolioTitle: "Portfolio de Ingeniería de Datos",
    viewLive: "Ver en vivo",
    explore: "Explorar",
    showMore: "Mostrar Más",
    showLess: "Mostrar Menos",
    downloadPdf: "Descargar Portafolio como PDF",
    generatingPdf: "Generando PDF...",
    selectProjects: "Seleccionar Proyectos",
    selectAll: "Seleccionar Todo",
    cancel: "Cancelar",
    downloadSelected: "Descargar",
    webProjects: [
      {
        title: "Sitio Web Maju Cipta Karya",
        description: "Maju Mapan es una marca de muebles moderna que combina diseño elegante con sostenibilidad. Cada pieza está hecha a mano por artesanos locales utilizando materiales ecológicos, aportando comodidad, equilibrio y calidez a cada espacio vital.",
      },
      {
        title: "Sitio Web Tcuber Store",
        description: "Tcuber Store es una plataforma confiable de recarga de juegos en línea en Indonesia, que proporciona créditos digitales rápidos, seguros y asequibles para juegos populares como Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans y PUBG Mobile. Ofrecemos varios métodos de pago y soporte receptivo para garantizar una experiencia de juego fluida.",
      },
    ],
    dataProjects: [
      {
        title: "Análisis de datos de pingüinos con IA",
        description: "Herramienta de exploración de datos interactiva impulsada por IA. Analiza datos de especies de pingüinos con preguntas en lenguaje natural y visualiza información a través de gráficos dinámicos. Construido con React, Recharts y Lovable AI.",
      },
    ],
    penguinExplorer: {
      title: "Preguntar sobre pingüinos",
      selectQuestion: "¿Qué te gustaría saber?",
      submit: "Enviar",
      analyzing: "Analizando...",
      thinking: "Pensando...",
      errorLoading: "Error al cargar datos de pingüinos",
      errorAnalyzing: "Error al analizar datos",
      rateLimitError: "Límite de velocidad excedido. Por favor, inténtelo de nuevo más tarde.",
      paymentError: "Se requiere pago. Por favor, agregue créditos a su espacio de trabajo de Lovable AI.",
      speciesDistribution: "Distribución de especies",
      billVsBody: "Longitud del pico vs masa corporal",
      dataTable: "Vista previa de datos",
      questions: [
        "¿Qué pingüinos tienen el pico más largo?",
        "¿Dónde viven los pingüinos más pesados?",
        "¿Qué pingüinos tienen las aletas más cortas?",
      ],
    },
  },
  skills: {
    title: "Habilidades",
    subtitle: "Infraestructura en la nube, automatización y CI/CD, sobre una base de ingeniería de datos empresarial",
    categories: {
      cloud: "Cloud e infraestructura",
      iac: "IaC y GitOps",
      cicd: "CI/CD",
      containers: "Contenedores y observabilidad",
      security: "Seguridad y redes",
      databases: "Bases de datos",
      etl: "ETL e integración",
      programming: "Programación",
      soft: "Habilidades blandas",
    },
  },
  certificates: {
    title: "Certificados Dataiku",
    subtitle: "Certificaciones profesionales en ciencia de datos, aprendizaje automático e IA de Dataiku",
    clickToView: "Haz clic para ver el certificado completo",
    download: "Descargar",
    verify: "Verificar",
    preview: "Vista previa del certificado",
  },
  awards: {
    title: "Premios y Certificaciones",
    subtitle: "Certificaciones profesionales en plataformas de datos, infraestructura en la nube y tecnologías de AI",
    view: "Ver",
  },
  contact: {
    title: "Ponte en contacto",
    subtitle: "Abierto a oportunidades, colaboraciones y solicitudes de conferencias",
    info: "Información de contacto",
    email: "Correo electrónico",
    phone: "Teléfono",
    social: "Redes sociales",
    sendMessage: "Enviar un mensaje",
    name: "Nombre",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "Mensaje",
    messagePlaceholder: "Masukkan pesan",
    send: "Enviar mensaje",
    copyright: "© 2025 Widyo Tri Cahya Utomo. Todos los derechos reservados.",
  },
  whatsapp: {
    title: "Conectemos",
    subtitle: "Elige cómo te gustaría contactarnos",
    chatbot: "Chatear con Asistente IA",
    whatsapp: "Mensaje por WhatsApp",
    defaultMessage: "¡Hola Widyo! Me gustaría conectar contigo.",
  },
  chatbot: {
    title: "Asistente IA",
    welcome: "¡Hola! Soy el asistente IA de Widyo. Puedo responder preguntas sobre su experiencia, habilidades y proyectos. ¿Cómo puedo ayudarte?",
    placeholder: "Escribe tu mensaje...",
    error: "Lo siento, se produjo un error. Por favor, inténtalo de nuevo.",
  },
};
